module.exports = require("hawk");